  <template>
  <div class="question">
    <el-card
      v-bind:class="[question.answered ? 'is-answered' : 'not-answered']"
      shadow="hover"
    >
      <div class>
        <div class="question-header">
          <h3>
            Question
          </h3>
          <small>
            {{ timeAgo.format(question.timestamp) }}
          </small>
        </div>
        <div>
          {{ question.question }}
        </div>
      </div>

      <el-divider></el-divider>

      <div v-if="question.answered">
        {{ question.answer }}
      </div>
      <div class="no-answer" v-else>
        No answer yet.
      </div>
    </el-card>
  </div>
</template>


<script>
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";

TimeAgo.addLocale(en);
export default {
  name: "Question",
  props: ["question"],
  data() {
    return {
      timeAgo: new TimeAgo("en-US")
    };
  },
  created() {},
  methods: {
    deleteQuestion() {
      const toDelete = {
        id: this.question.id
      };
      this.$emit("delete-question", toDelete);
    }
  }
};
</script>

<style scoped>
.question {
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: left;
}

.question-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

h3 {
  margin-top: 0px;
}

.no-answer {
  color: gray;
}

.is-answered {
  background-color: lavender;
}

.not-answered {
  background-color: lightpink;
}
.el-divider {
  background-color: black;
}
</style>